var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "rb-tiles-wrapper grid grid--gap-1",
      class: _vm.slideSlot.length > 2 ? "col-6" : "col-4",
    },
    _vm._l(_vm.slideSlot, function (slot, index) {
      return _c(
        "rb-dynamic-grid-column",
        { key: index, attrs: { index: index, "is-banner": true } },
        [_vm._t("default")],
        2
      )
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }